<template>
  <table class="table">
    
      <tr>
        <td>First Name</td>
        <td>{{ contactUs.firstName }}</td>
      </tr>
    
    
      <tr>
        <td>Last Name</td>
        <td>{{ contactUs.lastName }}</td>
      </tr>
    
    
      <tr>
        <td>Email</td>
        <td>{{ contactUs.email }}</td>
      </tr>
    
    
      <tr>
        <td>Name of Institution/Organization</td>
        <td>{{ contactUs.nameOrg }}</td>
      </tr>
    
    
      <tr>
        <td>Message</td>
        <td>{{ contactUs.message }}</td>
      </tr>
    
  </table>
</template>

<script setup lang="ts">
import { ContactUs } from "@/types";

// eslint-disable-next-line no-undef
const props = defineProps<{
  contactUs: ContactUs;
}>();
</script>

<style scoped>
table {
  width: fit-content;
  box-shadow: 0px 0px 10px 4px rgb(0 0 0 / 30%);
  border-radius: 6px;
  background: #fafafa;
  padding: 1rem;
  margin-top: 1rem;
  margin-left: auto;
  margin-right: auto;
}

thead td {
  text-align: center;
}

td {
  border: 2px solid #f0f0f0;
  border-collapse: collapse;
  padding: 0.2em 2em;
  font-size: larger;
  overflow-wrap: break-word;
}
</style>
